import { render, staticRenderFns } from "./lotteryAct.vue?vue&type=template&id=afc175a6&scoped=true&"
import script from "./lotteryAct.vue?vue&type=script&lang=js&"
export * from "./lotteryAct.vue?vue&type=script&lang=js&"
import style0 from "./lotteryAct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./lotteryAct.vue?vue&type=style&index=1&id=afc175a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc175a6",
  null
  
)

component.options.__file = "lotteryAct.vue"
export default component.exports